import './index.css'
import { DISCOVERY_SUITE } from '@disco/constants/billing-provider-components'
import { PLAN_ACTIVE } from '@disco/constants/FeatureTypes'
import { useEnableChangeAddOns } from '@disco/state-management/selectors/addOns'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import { getSubscription } from '@disco/state-management/selectors/subscription'
import { getCurrentQuota } from '@disco/utils/pricing'
import {
  getDSQuota,
  getDSQuotaUsed,
  getTracksQuota,
} from '@disco/state-management/selectors/user'

import React from 'react'
import { useSelector } from 'hooks/use-redux'
import AddOns from './AddOns'
type Props = {
  isModalExplorerRoute?: boolean
  trackId?: number
}

const DiscoverySuiteContainer = ({
  isModalExplorerRoute,
  trackId,
}: Props): React.ReactNode => {
  // @TODO SUB-543 : Consolidate a lot of these into AddOns.tsx
  const user = useSelector(state => state.user)
  const subscription = useSelector(getSubscription)
  const { address, address_2, city, country, state, zip } = subscription
  const userId = user?.id
  const businessId = user?.business?.id
  const tracksQuota = useSelector(getTracksQuota)
  const { client_libraries_trial, auto_tagged_tracks_trial } =
    user?.business?.private_metadata || {}
  const seatsAndTracks = useSelector(state => state.seatsAndTracks)
  const enableChangeAddOns = useEnableChangeAddOns({
    isDS: true,
  })
  let quota = useSelector(getDSQuota)
  const quotaUsed = useSelector(getDSQuotaUsed)
  const plans = user?.business?.private_metadata?.plans
  const enableDS = plans?.some(({ slot }) => slot === 'discovery_suite')
  const quotaUpdating = seatsAndTracks?.items[DISCOVERY_SUITE]
  const disabled = !useFeatureEnabled(PLAN_ACTIVE) && !enableDS

  if (!enableDS) {
    quota = 0
  }

  return (
    <AddOns
      tracksQuota={tracksQuota}
      isModalExplorerRoute={isModalExplorerRoute}
      trackId={trackId}
      quota={quota}
      quotaUsed={quotaUsed}
      quotaUpdating={quotaUpdating}
      enableDS={enableDS}
      unsubscribeAvailable={Boolean(quota)}
      disabled={disabled}
      disabledUpdatePaymentDetails={
        !user.permissions?.includes('can_change_business_settings') ||
        !subscription?.subscription_id
      }
      enableChange={enableChangeAddOns}
      client_libraries_trial={client_libraries_trial}
      auto_tagged_tracks_trial={auto_tagged_tracks_trial}
      contactInformation={{
        address,
        address_2,
        city,
        country,
        state,
        zip,
        reference: `${businessId}-${userId}`,
      }}
      type={DISCOVERY_SUITE}
    />
  )
}

export default DiscoverySuiteContainer
